import React from 'react';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';
import { Element } from 'react-scroll';
import { Link } from 'react-router-dom';

const CaseStudy = () => {
  const outcome1 = "✓";
  const outcome2 = "✓";
  const outcome3 = "✓";
  const outcome4 = "✓";

  return (
    <>
      <Element
        name="CaseStudy"
        className="datatalent-section-gap mea-key-features"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "Case Study"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              {/* <p className="text-center">How we helped a precision manufacturing company embrace Industry 4.0.</p> */}
            </div>
            <div className="single-case-study-card d-flex flex-column flex-md-row align-items-center justify-content-between bg-white p-4 p-md-5">
              <div className="col-12 col-md-8">
                <div className="d-flex flex-row align-items-center justify-content-start gap-4">
                  <div className="icon-image-box h-100">
                    <img src={`${process.env.PUBLIC_URL}/images/icons/factory.svg`} alt="factory" />
                  </div>
                  <div className="title-and-subtitle">
                    <h5 className="mb-0 lh-1">Beam Group</h5>
                    <p className="mb-0">Regulatory Sentiment Analysis for Beam Group</p>
                  </div>
                </div>
                <h6 className="mt-5 mb-4">The Challenge</h6>
                <p>Beam Group partnered with M2M Tech to create a tool in tracking public sentiment, complaints, and emerging regulatory trends across social media platforms like Reddit, Twitter, and YouTube.</p>
                <h6 className="mb-4">Our Approach</h6>
                <p className="mb-0">We developed a BERT-based NLP system integrated with LLMs to classify issues (e.g., noise, property management), detect regulatory red flags, and feed them into a live dashboard.</p>
                <h6 className="mt-5 mb-4">Key Results</h6>
                <ul>
                  <li>Multi-platform AI-driven data ingestion and issue categorization</li>
                  <li>85-92% model confidence in classifying resident concerns</li>
                  <li>Real-time dashboard for regulators with issue-specific drill-downs</li>
                  <li>Automated summaries reduced manual workload for oversight bodies</li>
                </ul>
                <h6 className="mb-4">Impact</h6>
                <p className="mb-0">The solution empowers regulators to track trends dynamically, respond proactively, and reduce manual monitoring costs-all while enabling long-term AI-powered oversight.</p>
              </div>
              <div className="col-12 col-md-4 mt-4 md-mt-0">
                <div className="single-case-study-stats ms-md-4 p-4 p-md-5">
                  <h6>Key Outcomes</h6>
                  <div className="d-flex flex-row align-items-center justify-content-between">
                    <small>Employment Services Recommendation Tool</small>
                    <small>{outcome1}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="reduced-downtime-progress" style={{width: outcome1}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Risk-Based Regulatory Tracking & Predictions</small>
                    <small>{outcome2}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="quality-improvement-progress" style={{width: outcome2}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Automated Risk-Based Licensing Dashboard</small>
                    <small>{outcome3}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="oee-increase-progress" style={{width: outcome3}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Social Media Monitoring for Condo Boards</small>
                    <small>{outcome4}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="roi-timeline-progress" style={{width: outcome4}}></div>
                  </div>
                    <Link className="edu-btn btn-primary btn-small w-100 text-center mt-5" to="/contact-us">Request Full Case Study</Link>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default CaseStudy;